// Radio and checkbox inputs (the tool switch, "Own tolerance") keep focus after a click, so
// they must not block shortcuts; slider handles use the arrow keys themselves.
export const ownsKeyboard = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  target.closest(
    'input:not([type="radio"]):not([type="checkbox"]), textarea, [contenteditable], [role="slider"]'
  ) != null;
